import clsx from 'clsx';

import styles from './Spinner.module.css';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return <span role="status" aria-label="Loading" className={clsx(styles.spinner, styles[size], className)} />;
}

export function LoadingBlock({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className={styles.centered}>
      <Spinner />
      <span>{label}</span>
    </div>
  );
}
